<template>
    <div>
    <div class="popup__header">
        <div class="title">Рабочее время сотрудника</div>
        <div class="subtitle mt4 text-bold text-color-white-trans">
            {{ user.firstName }} {{ user.lastName }}
        </div>
    </div>


    <div class="popup__content">
        <div class="mb40 mt40 df">
            <div class="mr24" style="width: 76px">
                <input-select
                        @change="changeTime($event)"
                        :value="startTime"
                        :placeholder="'Начало'"
                        :list-style="{'max-height': 192 + 'px'}">
                    </input-select>
            </div>
            <div class="mr24" style="width: 76px">
                <input-select
                        :value="endTime"
                        :placeholder="'Конец'"
                        :disabled="true"
                        :list-style="{'max-height': 192 + 'px'}">
                    </input-select>
            </div>
            <div class="text-italic text-size-xs text-color-grey">
                Рабочее время составляет 9 часов<br>и включает 1 час перерыва на обед
            </div>
        </div>
        <div class="df df-space-between mt40">
            <submit-btn @click="send" tag="button" :type="btnType">
                Сохранить
            </submit-btn>
        </div>
    </div>
</div>
</template>

<script>
    import Tooltip from '@/components/Tooltip.vue';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue';
    import TextareaField from '@/components/forms/TextareaField.vue';
    import InputSelect from '@/components/forms/InputSelect.vue';
    import {mapState} from "vuex";

    export default {
        name: "workTime",
        components: {
            Tooltip,
            SubmitBtn,
            TextareaField,
            InputSelect,
        },
        props: {

        },
        watch: {

        },
        data: function () {
            return {
                btnType: 'normal',
                startTime: 9,
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                user: state => state.auth.user,
                options: state => state.options,
            }),
            endTime(){
                return this.startTime > 14 ? -(24 - this.startTime - 9)  : this.startTime + 9;
            },
        },
        mounted: function () {
            if(this.user.workTimeStart){
                this.startTime = +this.user.workTimeStart.split(':')[0]
            }
        },
        emits: ['update:modelValue', 'calendarshow','set'],
        methods: {
            changeTime(event){
                this.startTime = event;
            },
            send(){
                let error = false;
                for(let field in this.form){
                    let errorField = false;
                    this.form[field].error = false;

                    if(field == 'text' && this.form[field].value.length == 0){
                        errorField = true;
                    }

                    if(errorField){
                        error = true;
                        setTimeout(() => {
                            this.form[field].error = true;
                        });
                    }
                }
                if(!error) {
                    this.btnType = 'load';
                    this.$store.dispatch('workers/setWorkTime',{start:this.startTime, end: this.endTime }).then(() => {
                        this.btnType = 'ok';
                        this.$emit('set');
                        setTimeout(()=>{
                            this.$store.commit('popups/close', {name: this.popups.workTime.name});
                        }, this.options.delayPopupClose);
                    },()=>{});
                }
            },
            removeError(form) {
                form.error = false;
            },
        },
    }
</script>

<style scoped>
</style>
